<template>
  <div class="form-samplecloth-cboxcontents">
    <div class="form-samplecloth__btn">
      <button type="button" class="js-samplecloth" href="#inline-content">生地を選ぶ</button>
    </div>
    <template v-for="(choice, index) in chosenItems">
      <div class="form-samplecloth__checkv2" :key="index">
        <div class="form-samplecloth__checkv2-pho">
          <picture>
            <img :src="choice.url" alt="" />
          </picture>
        </div>
        <p class="form-samplecloth__checkv2-text">{{ choice.name }}</p>
        <input type="hidden" name="cloth_names[]" :value="choice.name" />
        <div class="form-samplecloth__check__btn">
          <button type="button" @click="choices.splice(index, 1)">削除</button>
        </div>
      </div>
    </template>
    <div class="form-samplecloth__btn" v-if="choices.length !== 0">
      <button type="button" class="js-samplecloth" href="#inline-content">生地を選ぶ</button>
    </div>
    <div class="cloth-colorbox" id="inline-content">
      <section class="cloth-colorbox__container">
        <h2 class="cloth-colorbox__title">生地一覧</h2>
        <table class="cloth-colorbox__table">
          <template v-for="(cloth, clothIndex) in clothes">
            <tr :key="clothIndex">
              <th>
                <dl>
                  <dt>{{ cloth.category }}</dt>
                  <dd><span>素材：</span><span v-html="cloth.material"></span></dd>
                </dl>
              </th>
              <td>
                <ul class="cloth-colorbox__table-colorlist">
                  <template v-for="(color, colorIndex) in cloth.items">
                    <li class="cloth-colorbox__table-colorlist__item" :key="color.url">
                      <input
                        type="checkbox"
                        :id="'colorlist__item' + clothIndex + '-' + colorIndex"
                        :value="{ name: cloth.category + color.name, url: color.url }"
                        v-model="choices"
                      />
                      <label :for="'colorlist__item' + clothIndex + '-' + colorIndex">
                        <div class="cloth-colorbox__table-colorlist__item__pho">
                          <img :src="color.url" :alt="cloth.category + color.name" />
                        </div>
                        <p>{{ color.name }}</p>
                        <p v-if="color.note" class="cloth-colorbox__table-colorlist__item__note">{{ color.note }}</p>
                      </label>
                    </li>
                  </template>
                </ul>
              </td>
            </tr>
          </template>
        </table>
      </section>
      <div class="cloth-colorbox__btn">
        <a href="javascript:void(0)" id="addClothes" @click="addClothes()">チェックした生地を追加する</a>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'Clothes',
  props: {
    clothes: Array,
    clothNames: Array,
  },
  data() {
    return {
      choices: [],
      chosenItems: [],
    };
  },
  mounted() {
    if (this.clothNames.length) {
      for (const index in this.clothNames) {
        const choseName = this.clothNames[index];

        for (const clothIndex in this.clothes) {
          const cloth = this.clothes[clothIndex];

          for (const colorIndex in cloth.items) {
            const color = cloth.items[colorIndex];
            if (choseName === cloth.category + color.name) {
              this.choices.push({ name: cloth.category + color.name, url: color.url });
            }
          }
        }
      }
      this.chosenItems = this.choices;
    }
    //下選択ボタンが表示された時用にディレイをかませてカラーボックス作成
    setTimeout(this.setColorBox, 100);
  },
  methods: {
    addClothes() {
      if (this.choices.length > 3) {
        alert('選択できるのは３柄までです');
        return false;
      }

      this.chosenItems = this.choices;
      $('.js-samplecloth').colorbox.close();

      //下の選択ボタンが表示される時用、表示された後にカラーボックス再作成
      setTimeout(this.setColorBox, 100);
    },

    setColorBox() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        /* ウィンドウサイズが 768px以下の場合のコードをここに */
        $('.js-samplecloth').colorbox({
          innerWidth: '87.5%',
          margin: '0 auto',
          inline: true,
        });
      } else {
        /* ウィンドウサイズが 768px以上の場合のコードをここに */
        $('.js-samplecloth').colorbox({
          inline: true,
          innerWidth: '874',
        });
      }
    },
  },
};
</script>

<style scoped>
</style>
